import localeFormatNumber from "/shared/helpers/number-formatter.helper";

export default localeFormatNumber;
